import { cn } from '@ui/utils/cn';

import logoWhite from '@svg/v2/logo_white.svg';

interface LeftPanelProps {
  isMobile: boolean;
}

export function LeftPanel({ isMobile }: LeftPanelProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center bg-[#252525]',
        isMobile
          ? 'absolute inset-0'
          : 'relative w-1/2',
      )}
    >
      {/* 로고 - 패널 전체 기준 정중앙 */}
      <img
        src={logoWhite}
        alt="logo"
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 object-contain',
          isMobile ? 'w-[40%]' : 'w-[40%]',
        )}
      />

      {/* 머신 이미지 - 하단 중앙 */}
      <div
        className={cn(
          'absolute bottom-0 left-1/2 -translate-x-1/2 shrink-0',
          isMobile ? 'w-[314px]' : 'w-2/3',
        )}
      >
        <picture className="block">
          <source srcSet="/images/img_intro_machine.avif 2x" type="image/avif" />
          <source srcSet="/images/img_intro_machine.webp 2x" type="image/webp" />
          <img
            src="/images/img_intro_machine.jpg"
            srcSet="/images/img_intro_machine.jpg 2x"
            alt="machine"
            width={608}
            height={344}
            className="w-full object-contain"
          />
        </picture>
      </div>
    </div>
  );
}
